export type {
  AcceptResult,
  Proposal,
  ProposalAction,
  Proposer,
  ProposerContext,
} from "./proposer.js";

export type { ExpectedShape, LLMJudge } from "./llm-judge.js";

export type { FingerprintInput } from "./fingerprint.js";
export { computeFingerprint } from "./fingerprint.js";

export type { DocWriteAction, WriteDocResult } from "./doc-writer.js";
export { writeDocAction } from "./doc-writer.js";

export type { DeclinedEntry, ProposalKind } from "./decline-store.js";
export {
  loadDeclinedFingerprints,
  recordAcceptance,
  recordDecline,
  resetDeclined,
} from "./decline-store.js";

export type {
  InsightInput,
  InsightProposal,
  InsightProposerOptions,
  TopicTreeSnapshot,
  TurnRecord,
} from "./insight-proposer.js";
export { InsightProposer } from "./insight-proposer.js";

export type {
  HubInput,
  HubProposal,
  HubProposerOptions,
} from "./hub-proposer.js";
export { HubProposer } from "./hub-proposer.js";

export { AmbientBackpressure, TurnBuffer } from "./ambient-tracker.js";

export { AmbientRecaller, deriveQueryFromTurns } from "./ambient-recaller.js";
export type {
  AmbientRecallHit,
  AmbientRecallResult,
  AmbientRecallerOptions,
  RecallFn,
  RecallSuggestion,
} from "./ambient-recaller.js";

// Shared adapter base — host authors can build their own adapter from these
// without subclassing (frame + parse + error family).
export type { InjectedInvoker } from "./adapters/shared.js";
export {
  InjectedLLMJudge,
  LLMJudgeError,
  frameForJudge,
  parseJudgeResponse,
} from "./adapters/shared.js";

// First-party host adapters (one per sessionArchive host).
export type { ClaudeCodeSubAgentInvoker } from "./adapters/claude-code.js";
export {
  ClaudeCodeLLMJudge,
  ClaudeCodeLLMJudgeError,
} from "./adapters/claude-code.js";
export type { CodexCompletionInvoker } from "./adapters/codex.js";
export { CodexLLMJudge, CodexLLMJudgeError } from "./adapters/codex.js";
export type { GeminiMcpInvoker } from "./adapters/gemini.js";
export { GeminiLLMJudge, GeminiLLMJudgeError } from "./adapters/gemini.js";
export type { ClaudeDesktopInvoker } from "./adapters/claude-desktop.js";
export {
  ClaudeDesktopLLMJudge,
  ClaudeDesktopLLMJudgeError,
} from "./adapters/claude-desktop.js";
